// Sign Up API function
// Removed unused imports
// import { API_PATHS } from "../paths";
// import axios from "axios";
import axios from "axios";
import User from "../Model/UserModel";
import { API_PATHS } from "../paths";
import { flashMessage } from "../../utils/flashMessageService";

/**
 * Sign up a new user.
 * @param {Object} userData - The user data to register.
 * @returns {Promise} A promise that resolves to the server response.
 */
export const signUpUser = async (userData) => {
  try {
    // Convert frontend user data to API format using UserModel
    const user = new User(
      userData.fullName,
      userData.userName,
      userData.userType,
      // dob: userData.dob,
      userData.email,
      userData.profilePhoto,
      userData.organization,
      userData.phoneNumber,
      userData.jobTitle,
      userData.regions
    );
    const apiPayload = {
      ...user.toJSON(),
      password: userData.password,
      passwordConfirm: userData.passwordConfirm, // Add password and passwordConfirm only in API payload
      termsAccepted: userData.termsAccepted ? "true" : "false",
    };

    const formData = new FormData();
    Object.entries(apiPayload).forEach(([key, value]) => {
      if (value === undefined || value === null) return;

      if (Array.isArray(value)) {
        const normalized = value.map((entry) => (entry === undefined || entry === null ? "" : entry));
        if (!normalized.length) {
          formData.append(`${key}[]`, "");
        } else {
          normalized.forEach((entry) => formData.append(`${key}[]`, entry));
        }
        formData.append(key, JSON.stringify(normalized));
        return;
      }

      formData.append(key, value);
    });
    const response = await axios.post(API_PATHS.users, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.status !== 200 && response.status !== 201) {
      flashMessage(`Error: ${response.data?.error || response.statusText}`, { type: "error" });
      throw new Error(`Unexpected response status: ${response.status}`);
    }

    return response.data; // Convert API response to UserModel
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("Sign up failed with status 400:", error.response.data);
      flashMessage(`Sign up failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error signing up user:", error);
      flashMessage("Sign up failed. Please try again.", { type: "error" });
    }

    throw error;
  }
};
